export default __webpack_public_path__ + "static/media/fd-gray.06045155.svg";